import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=6afbd1fc&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afbd1fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6afbd1fc')) {
      api.createRecord('6afbd1fc', component.options)
    } else {
      api.reload('6afbd1fc', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=6afbd1fc&scoped=true&", function () {
      api.rerender('6afbd1fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2oemp7vQ8aIdh/JS/comp/SearchFilterTokens.vue"
export default component.exports